import React from 'react';
import { useFormikContext } from 'formik';
import Field from 'legacy/common/components/wysiwyg-form/Field';
import ToggleField from 'legacy/common/components/wysiwyg-form/ToggleField';
import TicketQuestions from '../../../../TicketQuestions';
import { Popup } from 'semantic-ui-react';
import { CURRENCY_CODES } from 'legacy/util/constants';
import { UserMe } from 'legacy/user/types';

import styles from '../../../FormStyles.module.scss';

interface StandardProductFieldsProps {
  isAddon?: boolean;
  user: UserMe;
  isUnsaved: (field: string) => boolean;
}

const StandardProductFields: React.FC<StandardProductFieldsProps> = ({
  isAddon,
  user,
  isUnsaved
}) => {
  const { values } = useFormikContext<any>();
  const productTypeLabel = isAddon ? 'items' : 'tickets';

  return (
    <>
      {/* Common fields specifically configured for Standard products */}
      <div>
        <Field
          name="name"
          id="name"
          type="text"
          label={`${isAddon ? 'Add-on' : 'Ticket'} Name* ${
            isUnsaved('name') ? '(unsaved)' : ''
          }`}
          disabled={!values.canDelete}
          placeholder={
            isAddon ? 'e.g. VIP Merchandise Bundle' : 'e.g. General Admission'
          }
        />
        <Field
          type="text"
          id="description"
          name="description"
          label={`Description* ${isUnsaved('description') ? '(unsaved)' : ''}`}
          placeholder={
            isAddon
              ? 'e.g. Includes t-shirt and poster'
              : 'e.g. Standard entry to the event'
          }
        />
      </div>

      <div className="flex gap-6">
        <Field
          id="maxQuantity"
          name="maxQuantity"
          type="number"
          label={`Available ${productTypeLabel}*`}
          placeholder="e.g. 50"
        />

        {/* Price field */}
        {!values.canDelete && (
          <span className={styles.tooltip}>
            <Popup
              hoverable
              position="right center"
              trigger={<i className="fa fa-info-circle" />}
              size="tiny"
              content="Price cannot be edited after guests have bought a ticket"
            />
          </span>
        )}

        <Field
          id="price"
          name="price"
          type="number"
          disabled={!values.canDelete}
          label={`Price (${CURRENCY_CODES[user?.country]})* ${
            isUnsaved('price') ? '(unsaved)' : ''
          }`}
          placeholder="e.g. $50"
        />
      </div>

      <div className="mt-6">
        <ToggleField
          name="purchaseRequirements.requiresApproval"
          label="Require approval"
        />
        {values.purchaseRequirements?.requiresApproval && (
          <TicketQuestions name="purchaseRequirements.questions" />
        )}
      </div>
    </>
  );
};

export default StandardProductFields;
